import { render, staticRenderFns } from "./LabelledFieldAlt.vue?vue&type=template&id=2f58d566&scoped=true&"
import script from "./LabelledFieldAlt.vue?vue&type=script&lang=js&"
export * from "./LabelledFieldAlt.vue?vue&type=script&lang=js&"
import style0 from "./LabelledFieldAlt.vue?vue&type=style&index=0&id=2f58d566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58d566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
